import { render, staticRenderFns } from "./PendenciasFinalizacao.vue?vue&type=template&id=2c66cad9&scoped=true"
import script from "./PendenciasFinalizacao.vue?vue&type=script&lang=js"
export * from "./PendenciasFinalizacao.vue?vue&type=script&lang=js"
import style0 from "./PendenciasFinalizacao.vue?vue&type=style&index=0&id=2c66cad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66cad9",
  null
  
)

export default component.exports